import { render } from "./IASubscribeThanks.vue?vue&type=template&id=6197b156"
const script = {}
script.render = render

export default script